import React, { useState } from "react";
import ContactUsMessage from "organisms/resources/contact-us-message";

import { useHistory } from "react-router-dom";
import { siteMap } from "internal-sitemap";

import CustomizeExperienceFavorites from "./customize-experience-favorites";

// -----------------------------------------------------------------------------------------
// #region Interfaces
// -----------------------------------------------------------------------------------------

interface CustomizeExperienceProps {}
export enum CustomizeExperienceStatus {
    SelectFavorites = 2,
}

// #endregion Interfaces

// -----------------------------------------------------------------------------------------
// #region Constants
// -----------------------------------------------------------------------------------------

export const BASE_CLASS = "c-customize-experience";

// #endregion Constants

// -----------------------------------------------------------------------------------------
// #region Component
// -----------------------------------------------------------------------------------------

const CustomizeExperience: React.FC<CustomizeExperienceProps> = () => {
    const history = useHistory();

    const onClickContinueToDashboard = () => {
        history.push(siteMap.dashboards.user);
    };

    return (
        <section className={BASE_CLASS}>
            <CustomizeExperienceFavorites
                onContinue={onClickContinueToDashboard}
            />
            {/* Additional experiences will go here */}
            <ContactUsMessage />
        </section>
    );
};

// #endregion Component

export default CustomizeExperience;
